"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClockIcon = require("./ClockIcon");

var _ClockIcon2 = _interopRequireDefault(_ClockIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ClockIcon2.default;